export const defaultConfig = [
  {
    title: "Apple",
    editable: true,
    group: [],
  },
]
